import { FC, JSX } from 'react';
import * as vp from 'vopay';
import styles from './AccountingSoftwareLayout.module.scss';

type AccountingSoftwareLayoutProps = {
  leftContent: JSX.Element;
  rightContent: JSX.Element;
  bottomRow: JSX.Element;
};

const { Box } = vp;

const AccountingSoftwareLayout: FC<AccountingSoftwareLayoutProps> = ({ leftContent, rightContent, bottomRow }) => (
  <div className={styles.container}>
    <Box flx="row" grow="1">
      <div className={styles.leftSection}>{leftContent}</div>
      <div className={styles.rightSection}>{rightContent}</div>
    </Box>
    <Box pt="md" flx="col" base="8" maxheight="60px">
      {bottomRow}
    </Box>
  </div>
);

export default AccountingSoftwareLayout;
